const drawerFactory = require('components/ui/drawer/js/main');
const aircrafmapLegendFactory = require('components/bags_and_seats/aircraftmap_legend/js/main.mobile');

module.exports = {
    create({el, keys, seatAvailabilityByType, onCloseDrawer, model}) {
        return drawerFactory.create({
            el,
            keys,
            contentFactory: aircrafmapLegendFactory,
            size: '-lg',
            position: '-right',
            extraOptions: {seatAvailabilityByType},
            onCloseDrawer: onCloseDrawer,
            model,
        });
    },
};
